// Version utility for Waddup application
export interface VersionInfo {
  version: string;
  buildTime: string;
  commitHash?: string;
  environment: string;
}

// Get version from environment or fallback
const getVersion = (): string => {
  return process.env.REACT_APP_VERSION || '1.0.0';
};

// Get build time
const getBuildTime = (): string => {
  return process.env.REACT_APP_BUILD_TIME || new Date().toISOString();
};

// Get commit hash (if available)
const getCommitHash = (): string | undefined => {
  return process.env.REACT_APP_COMMIT_HASH;
};

// Get environment
const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};

// Format version for display
export const formatVersion = (): string => {
  const version = getVersion();
  const commitHash = getCommitHash();
  const env = getEnvironment();
  
  if (env === 'production') {
    return commitHash ? `v${version} (${commitHash.slice(0, 7)})` : `v${version}`;
  }
  
  return `v${version} (${env})`;
};

// Get full version info
export const getVersionInfo = (): VersionInfo => {
  return {
    version: getVersion(),
    buildTime: getBuildTime(),
    commitHash: getCommitHash(),
    environment: getEnvironment()
  };
};

// Check if this is a development build
export const isDevelopment = (): boolean => {
  return getEnvironment() === 'development';
};

// Check if this is a production build
export const isProduction = (): boolean => {
  return getEnvironment() === 'production';
}; 